import { STORE_CHAT } from './action'

const initialState = {
  chat: null,
}

export default function chatReducer(state = initialState, action) {
  switch (action.type) {
    case STORE_CHAT:
      return {
        ...state,
        chat: action.data,
      }
    default:
      return state
  }
}
